/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Players_None_Of_YoursInputs */

const th_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณไม่ได้เป็นผู้ปกครองของผู้เล่นที่สมัครรายการนี้ได้`)
};

const en_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are not a guardian for anyone who could enter this.`)
};

const ja_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この大会に申し込める選手の保護者ではありません。`)
};

const zh_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你没有可以在此报名的被监护人。`)
};

const es_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No eres tutor de nadie que pueda inscribirse.`)
};

const pt_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não é responsável por ninguém que possa se inscrever.`)
};

const id_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda bukan wali siapa pun yang bisa mendaftar di sini.`)
};

const fr_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n’êtes tuteur de personne pouvant s’y inscrire.`)
};

const tl_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala kang tagapag-alagang maaaring sumali rito.`)
};

const vi_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không giám hộ ai có thể đăng ký ở đây.`)
};

const ko_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기에 등록할 수 있는 보호 대상이 없습니다.`)
};

const de_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist für niemanden erziehungsberechtigt, der sich hier melden könnte.`)
};

const ru_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы не являетесь опекуном никого, кто мог бы здесь заявиться.`)
};

const tr_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burada kaydolabilecek birinin velisi değilsiniz.`)
};

const it_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sei tutore di nessuno che possa iscriversi qui.`)
};

const pl_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie jesteś opiekunem nikogo, kto mógłby się tu zapisać.`)
};

const uk_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви не є опікуном нікого, хто міг би тут заявитися.`)
};

const hi_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप ऐसे किसी के अभिभावक नहीं हैं जो यहाँ पंजीकरण करा सके।`)
};

const ar_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لست وليّ أمر أحد يمكنه التسجيل هنا.`)
};

const ms_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda bukan penjaga sesiapa yang boleh mendaftar di sini.`)
};

const bn_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখানে নিবন্ধন করতে পারে এমন কারও অভিভাবক আপনি নন।`)
};

const zh_tw2_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你並非任何可在此報名者的監護人。`)
};

const zh_hk2_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你並非任何可在此報名者的監護人。`)
};

const ur_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کسی ایسے شخص کے سرپرست نہیں جو یہاں رجسٹر ہو سکے۔`)
};

const fa_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شما سرپرست کسی نیستید که بتواند اینجا ثبت‌نام کند.`)
};

const sw_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewe si mlezi wa mtu yeyote anayeweza kujisajili hapa.`)
};

const nl_event_players_none_of_yours = /** @type {(inputs: Event_Players_None_Of_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent van niemand voogd die zich hier kan inschrijven.`)
};

/**
* | output |
* | --- |
* | "You are not a guardian for anyone who could enter this." |
*
* @param {Event_Players_None_Of_YoursInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_players_none_of_yours = /** @type {((inputs?: Event_Players_None_Of_YoursInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Players_None_Of_YoursInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_players_none_of_yours(inputs)
	if (locale === "ja") return ja_event_players_none_of_yours(inputs)
	if (locale === "zh") return zh_event_players_none_of_yours(inputs)
	if (locale === "es") return es_event_players_none_of_yours(inputs)
	if (locale === "pt") return pt_event_players_none_of_yours(inputs)
	if (locale === "id") return id_event_players_none_of_yours(inputs)
	if (locale === "fr") return fr_event_players_none_of_yours(inputs)
	if (locale === "tl") return tl_event_players_none_of_yours(inputs)
	if (locale === "vi") return vi_event_players_none_of_yours(inputs)
	if (locale === "ko") return ko_event_players_none_of_yours(inputs)
	if (locale === "de") return de_event_players_none_of_yours(inputs)
	if (locale === "ru") return ru_event_players_none_of_yours(inputs)
	if (locale === "tr") return tr_event_players_none_of_yours(inputs)
	if (locale === "it") return it_event_players_none_of_yours(inputs)
	if (locale === "pl") return pl_event_players_none_of_yours(inputs)
	if (locale === "uk") return uk_event_players_none_of_yours(inputs)
	if (locale === "hi") return hi_event_players_none_of_yours(inputs)
	if (locale === "ar") return ar_event_players_none_of_yours(inputs)
	if (locale === "ms") return ms_event_players_none_of_yours(inputs)
	if (locale === "bn") return bn_event_players_none_of_yours(inputs)
	if (locale === "zh-TW") return zh_tw2_event_players_none_of_yours(inputs)
	if (locale === "zh-HK") return zh_hk2_event_players_none_of_yours(inputs)
	if (locale === "ur") return ur_event_players_none_of_yours(inputs)
	if (locale === "fa") return fa_event_players_none_of_yours(inputs)
	if (locale === "sw") return sw_event_players_none_of_yours(inputs)
	if (locale === "nl") return nl_event_players_none_of_yours(inputs)
	return en_event_players_none_of_yours(inputs)
});